import { imgUrlHandle, gmrfidCode } from '../../utils';

export default function Quick ({ options }) {
  const { menuData, authenticationType, list, history } = options;

  return (
    <div className="quick-block">
      {/* 认证 */}
      <div className="carousel">
        <img
          src={authenticationType ? '/icon1.png' : '/icon2.png'}
          alt="icon"
        />
      </div>

      {/* 应用分类 */}
      <div>
        {list.map((item, i1) => {
          return (
            <div className="app" key={i1}>
              <h1>{gmrfidCode.QUICKENTRY[item.title]}</h1>
              <ul>
                {item.children.map((item2, i2) => (
                  <li
                    key={i2}
                    onClick={() => {
                      if (item2?.children) {
                        history.push({
                          pathname: '/workbench/applicationMenu',
                          state: {
                            menuTitle: item2.name,
                            menuData: item2?.children || [],
                          },
                        });
                      } else {
                        history.push({
                          pathname: item2.uri,
                          state: item,
                        });
                      }
                    }}
                  >
                    <img src={imgUrlHandle(item2.appIcon)} alt="icon" />
                    <label>{item2.name}</label>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>

      {/* 快捷入口 */}
      {/* <div className="quick-entrance">
        <h1>快捷入口</h1>
        <ul>
          {menuData.map((item, i) => (
            <li
              key={i}
              onClick={() => {
                // 物业收费根据url判断的权限所以清空，默认进去第一个
                sessionStorage.setItem('property', '')
                history.push({
                  pathname: item.uri,
                  state: item
                })
              }}
            >
              <img src={imgUrlHandle(item.icon)} alt="appIcon" />
              <p>{item.name}</p>
            </li>
          ))}
        </ul>
      </div> */}

      {/* 下载中心 */}
      {/* <div className="quick-download">
        <h1>下载中心</h1>
        <ul>
          <li>
            <img src="/download.png" alt="download" />
            万家美慧客户端下载
          </li>
          <li>
            <img src="/download.png" alt="download" />
            使用手册下载
          </li>
        </ul>
      </div> */}
    </div>
  );
}
